import React from 'react';

export const useConversationSubscribe = () => {
  const [subscriptionError, setSubscriptionError] = React.useState(false);

  const setError = (err) => {
    if (err) {
      console.log(err); /* eslint-disable-line */
      setSubscriptionError(err);
      setTimeout(() => setSubscriptionError(false));
    }
  };

  return [subscriptionError, setError];
};

export default useConversationSubscribe;
